import api from './api';

// Fire-and-forget tour analytics. Never blocks or throws in the UI.
// tour: 'video' | 'guided'
// action: 'shown' | 'watched' | 'skipped' | 'completed' | 'opened'
// source: 'autoplay' | 'manual' | 'firstrun' | 'replay'
export const trackTour = (tour, action, source) => {
  try {
    api.post('/analytics/tour', { tour, action, source }).catch(() => {});
  } catch (e) {
    /* ignore analytics failures */
  }
};
